module.exports = __webpack_public_path__ + "static/media/product6.bc78783e.jpg";